"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _emojiMart = require("emoji-mart");
var _clsx = _interopRequireDefault(require("clsx"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Emoji = _interopRequireDefault(require("./Emoji.style"));
var _Picker = _interopRequireDefault(require("./Picker.style"));
var _emojiSheetMin = _interopRequireDefault(require("./img/emoji-sheet-min.jpg"));
var _dec, _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const DEFAULT_EMOJI_MART = {
  set: 'apple',
  sheetSize: 32,
  showPreview: false,
  backgroundImageFn: () => _emojiSheetMin.default
};
let Emoji = (_dec = (0, _reactJss.default)(_Emoji.default), _dec(_class = class Emoji extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  // Get EmojiMart settings ot get default settings
  getEmojiProps() {
    var _this$props;
    return _objectSpread(_objectSpread({}, DEFAULT_EMOJI_MART), ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.emojiMart) || {});
  }
  handleChange(value) {
    const {
      id,
      onChange
    } = this.props;
    onChange({
      id,
      value,
      error: false
    });
  }
  render() {
    const {
      classes,
      className,
      id,
      size,
      visibility
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.emoji, classes[size], {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      })
    }, /*#__PURE__*/_react.default.createElement(_Popover.default, {
      content: ({
        onClose
      }) => /*#__PURE__*/_react.default.createElement(_emojiMart.Picker, (0, _extends2.default)({}, this.getEmojiProps(), {
        onSelect: emoji => {
          this.handleChange(emoji);
          onClose();
        }
      })),
      anchors: {
        binding: _Popover.default.ANCHOR.left_top,
        content: _Popover.default.ANCHOR.left_bottom
      },
      padding: 4,
      topLevel: true,
      bindingElementRef: this.props.bindingElementRef
    }, ({
      onToggle
    }) => /*#__PURE__*/_react.default.createElement("div", {
      onClick: event => {
        onToggle();
        event.stopPropagation();
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: "smile",
      size: size
    }))));
  }
}) || _class);
Emoji.defaultProps = {
  visibility: 'visible',
  size: 'large',
  onChange: () => {}
};
const EmojiPicker = (0, _reactJss.default)(_Picker.default)(({
  onSelect: _onSelect,
  emojiMartProps,
  onClose
}) => /*#__PURE__*/_react.default.createElement(_emojiMart.Picker, (0, _extends2.default)({}, DEFAULT_EMOJI_MART, emojiMartProps, {
  onSelect: emoji => {
    _onSelect(emoji);
    onClose();
  }
})));
EmojiPicker.propTypes = {
  onSelect: _propTypes.default.func.isRequired,
  emojiMartProps: _propTypes.default.object,
  onClose: _propTypes.default.func.isRequired
};
EmojiPicker.defaultProps = {
  emojiMartProps: {}
};

// Add EmojiPicker as a static property to Emoji
Emoji.Picker = EmojiPicker;
var _default = exports.default = Emoji;